
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorSeccion} from '../controlador';
    import { Pedido } from '@/__env/lib/Ventas/Pedidos';
    import { Factura } from '@/__env/lib/CuentasCorrientes/Facturas';
    import { Utiles } from '@/__env/pluggins/event-bus';
    import * as Envios from '@/__env/lib/Ventas/Envios/Envio.nav';
    @Component( {
        name: "Componente",
        props: {},
        components: {}
    } )
    export default class Componente extends Vue
    {

        @Prop() public Controlador: ControladorSeccion;

        public Estado: string = '';
        public Pedido: Pedido = null;
        public CuentasTreggo = [
            { Nombre: 'JARSE INDUSTRIAL', Id: 'jarse-industrial' },
            { Nombre: 'CASA JARSE', Id: 'casa-jarse' }
            
        ];
        public CuentaTreggo: number = 0;

        public get Envio() { return this.Pedido.Envio; }

        public get SubModo() { return this.Controlador.Vista.BarraDerecha.SubModo; }
        public set SubModo( x: string ) { this.Controlador.Vista.BarraDerecha.SubModo = x; }
        public get Modo() { return this.Controlador.Vista.BarraDerecha.Modo; }
        public get Datos() { return this.Controlador.Vista.BarraDerecha.Datos; }
        public set Modo( x: string ) { this.Controlador.Vista.BarraDerecha.Modo = x; }
        public get ReservarEspacioDerecha() { return this.Controlador.Vista.BarraDerecha.Anchura.Espacio; }


        async mounted()
        {
            if ( this.Datos && this.Datos.pedido )
            {
                this.Pedido = await Pedido.create( this.Datos.pedido );
                if ( !this.Pedido )
                {
                    this.Cerrar();
                } else
                {
                    if ( this.Pedido.Envio.Tipo.esFlex )
                    {
                        this.Pedido.Envio.EmpresaLogistica.Codigo = 'D02';
                    } else
                    {
                        this.Pedido.Envio.Tipo = Envios.Tipos.Treggo;

                    }
                    
                }
            }
        }



        public Cargando: boolean = false;
        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }


        async Iniciar()
        {

        }

 

        async Guardar()
        {
            let errores = this.Envio.Validate();
            if ( !this.CuentasTreggo[this.CuentaTreggo].Id )
            {
                errores.push( 'La cuenta no es válida' );
            }

            if ( errores.hasRows() )
            {
                await Utiles.Mensajes.Aceptar( 'Se encontraron errores', errores.map( x => `<li>${x}</li>` ).join( '' ) );
                return;
            }

            this.Estado = 'cargando';
            let e = await this.Envio.crearRepartoTreggo( this.CuentasTreggo[this.CuentaTreggo].Id );
            if ( e )
            {
                this.Estado = 'ok';
                this.Pedido.Envio = this.Envio;
                this.$EventBus.Notificaciones.Completado( 'Guardado correctamente' );
                await this.Controlador.Buscador.Buscar();
            }
            else
            {
                this.Estado = 'ok';
                this.$EventBus.Notificaciones.Error( 'Error al guardar' );
            }
        }

    

        async Cerrar()
        {
            this.Modo = '';
        }

        public Refresh: boolean = false;
        Refrescar()
        {
            this.Refresh = false;
            this.$nextTick( () => this.Refresh = true );
        }
    }
